import * as React from "react";
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';


const CustomButton = styled(Button)(({ theme }) => ({
  borderRadius: "20px",
  color: "#ffffff",
  fontSize: "13px",
  textTransform: "none",
  backgroundColor: "#36899f",
  fontWeight: "bold",
  padding: "10px",
  '&:hover': {
    backgroundColor: "#36899f",
    boxShadow: "none",
  },
  boxShadow: "none"
}));

const YellowButton = styled(CustomButton)(({ theme }) => ({
  backgroundColor: "#ddb930",
  '&:hover': {
    backgroundColor: "#ddb930",
  },
}));

interface colorButtonProps {
  color: string,
  text: string,
  onClick?: ()=>void,
  disabled?: boolean,
}

const ColorButton:React.FC<colorButtonProps> = ({color, text, onClick, disabled}) => {
  return (
    color === "sky" ? <CustomButton onClick={onClick} variant="contained" disabled={disabled}>{text}</CustomButton>
      : <YellowButton onClick={onClick} variant="contained" disabled={disabled}>{text}</YellowButton>
  );
}

export default ColorButton;
